import { Component, ViewChild, inject } from '@angular/core';
import { BaseComponent } from '@core/base.component';
import { BreakpointService } from '@services/breakpoint.service';
import { ConfirmationService } from '@services/confirmation.service';
import { LoadingService } from '@services/loading.service';
import { TranslationService } from '@services/translation.service';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { LoadingScreenComponent } from '@shared/components/loading-screen/loading-screen.component';
import { takeUntil } from 'rxjs/operators';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'hubbs-root',
    template: `
		<section>
			<hubbs-loading-screen #loadingScreen></hubbs-loading-screen>
			<hubbs-loading-screen #genericLoadingScreen></hubbs-loading-screen>
			<hubbs-confirm-modal #confirmmodal></hubbs-confirm-modal>
			<router-outlet></router-outlet>
		</section>
	`,
    styles: [],
    imports: [
        ConfirmModalComponent,
        LoadingScreenComponent,
        LoadingScreenComponent,
        RouterOutlet,
    ]
})
export class AppComponent extends BaseComponent {
	private breakpointService = inject(BreakpointService);
	private loadingService = inject(LoadingService);
	private translationService = inject(TranslationService);
	private confirmationService = inject(ConfirmationService);

	@ViewChild('loadingScreen', { static: true }) loadingScreen: LoadingScreenComponent;
	@ViewChild('genericLoadingScreen', { static: true }) genericLoadingScreen: LoadingScreenComponent;
	@ViewChild('confirmmodal', { static: true }) confirmmodal: ConfirmModalComponent;

	constructor() {
		super();

		this.breakpointService.Initialize();

		this.loadingService.loadingEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
			next: (data) => {
				if (data.hasOwnProperty('key')) {
					this.loadingScreen.title = this.translationService.GetTranslation(data.key);
				}
				if (data.hasOwnProperty('show')) {
					this.loadingScreen.isLoading$.next(data.show);
				}
			},
		});

		this.loadingService.genericLoadingEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
			next: (data) => {
				if (data.hasOwnProperty('key')) {
					this.genericLoadingScreen.title = this.translationService.GetTranslation(data.key);
				}
				if (data.hasOwnProperty('show')) {
					if(this.loadingScreen.isLoading$ && data.show)
						return;
					
					this.genericLoadingScreen.isLoading$.next(data.show);
				}
			},
		});

		this.confirmationService.showConfirmation.pipe(takeUntil(this.ngUnsubscribe)).subscribe((dialogContent: any) => {
			this.confirmmodal.showConfirmation(dialogContent).then((result) => {
				this.confirmationService.confirmationResult.emit(result);
			});
		});
	}
}
